import React from 'react'
import styled, { css } from 'styled-components'
import { string } from 'prop-types'

import * as spacing from 'styles/spacing'
import { white } from 'styles/colors'
import { H2 } from 'styles/typography'
import { media } from 'styles/media'
import { cover } from 'styles/global'

import Marker from './Marker'

const Container = styled.div`
  width: 30vw;

  ${media.small`
    width: 35vw; /* Space devices out but keep device size the same */
  `};

  ${media.medium`
    flex: 1;
    width: auto;
  `};
`

const FigureWrap = styled.div`
  position: relative;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${spacing.medium};
  width: 65px;

  ${media.medium`
    width: 90px;
  `};

  ${media.large`
    width: 100px;
  `};

  &:after {
    content: '';
    display: block;
    padding-bottom: 555%;
  }
`

const Figure = styled.img`
  ${cover('absolute')};
`

const Name = styled(H2)`
  color: ${white};
  font-family: 'Trim Poster';
  text-align: center;

  ${props =>
    props.glowing &&
    css`
      position: relative;
      color: transparent;
      font-style: normal;
      -webkit-text-stroke: 1px ${white};

      &:after,
      &:before {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        content: attr(data-text);
        filter: blur(2px);
        white-space: nowrap;
      }
    `}
`

const Device = ({ slug }) => (
  <Container>
    <FigureWrap>
      {slug === 'epod' ? (
        <>
          <Marker
            x="50%"
            y="22%"
            text="Compact design available in 5 premium colours"
            direction="left"
            mobileDirection="left"
            mobileOffset={45}
            offset={70}
          />
          <Marker
            x="50%"
            y="48%"
            text="Green battery charge indicator light"
            mobileDirection="left"
            offset={70}
            mobileOffset={45}
          />
          <Marker
            x="94%"
            y="71.5%"
            text="Full battery charge in 80 minutes"
            mobileDirection="left"
            offset={26}
            mobileOffset={74}
          />
          <Marker
            x="3%"
            y="87.5%"
            text="Black magnetic USB charging cable"
            offset={24}
            mobileOffset={15}
            direction="left"
            mobileDirection="left"
          />
        </>
      ) : (
        <>
          <Marker
            x="78%"
            y="2%"
            text="Compatible with Vuse ePod Pods"
            offset={42}
            mobileOffset={25}
            mobileDirection="right"
          />
          <Marker
            x="50%"
            y="22%"
            text="Compact angular design with an anodized metal finish, available in 5 premium colours"
            offset={70}
            mobileOffset={44}
            mobileDirection="right"
          />
          <Marker
            x="13%"
            y="36%"
            text="Splash proof"
            offset={34}
            mobileOffset={67}
            direction="left"
            mobileDirection="right"
          />
          <Marker
            x="65%"
            y="47.5%"
            text="White LED 3-stage battery charge indicator light"
            offset={55}
            mobileOffset={34}
            mobileDirection="right"
          />
          <Marker
            x="90%"
            y="59.5%"
            text="Charges up to 80% in 35 minutes"
            mobileDirection="right"
            offset={30}
            mobileOffset={17}
          />
          <Marker
            x="6%"
            y="69.5%"
            text="Vape while you charge capability"
            offset={26}
            mobileOffset={72}
            direction="left"
            mobileDirection="right"
          />
          <Marker
            x="95%"
            y="86%"
            text="Cherry Red magnetic bespoke USB charging cable"
            offset={24}
            mobileOffset={15}
            mobileDirection="right"
          />
        </>
      )}

      <Figure src={`${process.env.BASE_PATH}/images/epod2/compare/${slug}.png`} />
    </FigureWrap>
    <Name data-text={slug === 'epod' ? 'ePod' : 'ePod 2'} glowing={slug === 'epod-2'}>
      {slug === 'epod' ? 'ePod' : 'ePod 2'}
    </Name>
  </Container>
)

Device.propTypes = {
  slug: string.isRequired
}

export default Device
